/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryOutSummaryDetailsQuery } from '../../models/get-inventory-out-summary-details-query';
import { GetInventoryOutSummaryDetailsQueryResult } from '../../models/get-inventory-out-summary-details-query-result';

export interface ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Params {
      body?: GetInventoryOutSummaryDetailsQuery
}

export function apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetInvOutSummaryDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryOutSummaryDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetInvOutSummaryDetailsReportPost.PATH = '/api/NurseryManager/Reports/GetInvOutSummaryDetailsReport';
